export function getEnv(key) {
  if (typeof global !== 'undefined') {
    return global.process.env[key];
  }
  return process.env[key];
}

/**
 * Retrieves the error message for a property from an errors object.
 *
 * @param errors
 * @param key
 * @returns {string}
 */
export function getErrorMessage(errors, key) {
  if (!errors.hasOwnProperty(key) || !errors[key] instanceof Array) {
    return '';
  }
  // Errors returned by the API is a list of strings for each validation failed. Join the validation messages
  // together into a single string.
  return errors[key].join(' ').replaceAll('form fields.', '');
}
